import React, { Component } from 'react';

var TestVatiant = React.createClass({
  handleClick: function(){
    this.props.actionTestSelect(this.props.id);
  },
  minusSizeVariantTest: function(){

    if(this.childItem && this.item && this.childItem.clientHeight > this.item.clientHeight){
      var newSize = this.item.style.fontSize.match(/\d\d/)[0] - 1 + 'px';
      this.item.style.fontSize = newSize;
      this.minusSizeVariantTest();
    }
  },
  componentDidMount: function(){
    this.minusSizeVariantTest()
  },
  componentDidUpdate: function(){
    if(this.item && this.childItem){
      this.item.style.fontSize = '32px';
      this.minusSizeVariantTest();
    }
  },
  render: function(){
    if(this.props.customVariant){
      console.log('this.props.text', this.props.text)
      return (
        <div ref={item => this.item = item} style={{fontSize: '32px', overflow: 'hidden'}} onClick={this.props.actionSelectCustomVariant} className={"variant" + (this.props.select ? ' select' : '')}>
          <div ref={item => this.childItem = item} style={{height: 'auto'}} className="center">{!this.props.text ? 'Свой вариант' : 'Свой вариант: ' + this.props.text}</div>
        </div>
      )
    }else{
      return(
        <div ref={item => this.item = item} style={{fontSize: '32px', overflow: 'hidden'}} onClick={this.handleClick} className={"variant" + (this.props.select ? ' select' : '')}>
          <div ref={item => this.childItem = item} style={{height: 'auto'}} className="center">{this.props.text}</div>
        </div>
      );
    }
    
  }
});

export default TestVatiant;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/TestVariant/index.jsx
 **/